import React from 'react'
import './examCard.css'
import ghadi2 from '../../../assets/products/ghadi2.png'
import teer from '../../../assets/products/teer.png'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import config from '../../../config'
import URL from '../../../api/url'
import { ToastContainer, toast } from 'react-toastify'

// let testpurl = URL[config.env].WEB_TEST_PANEL_URL;

class ExamcardPr extends React.Component  {
    constructor(props)
  {super(props);
   this.testpurl = !props.demo_account ? URL[config.env].WEB_TEST_PANEL_URL : URL[config.env].WEB_TEST_PANEL_URL2;
}
render() {

   let authToken = this.props.auth.institute_id+":"+this.props.element_object.test_id+":"+this.props.auth.user_id+":"+this.props.auth.password;
   authToken=btoa(authToken);
   authToken = authToken.replaceAll("=", "$");

   return (
      <>
         <div className="exam-card">         
            <div className="side-margine">
            </div>
            <div className="exam-maindiv">
               <div className="remaining-div">
               <div className="exam-name">
                     <span className="examtopic-name" 
                     title={this.props.element_object.test_name}
                     >
                        {this.props.element_object.test_name.substr(0,47)}
                        {this.props.element_object.test_name.length>47 && "..."}
                     </span>               
                  </div>
                  <div >
                     <div className="exam-image-div">
                        <img src={teer} className="exam-dateimage"></img>
                        <div className="combine-date">
                           <span className="start-date">{this.props.t('exams.attempts')}</span>
                           <span className="start-dateformat">
                              {this.props.element_object.test_limit>0 &&
                              this.props.element_object.total_attempts + " " + this.props.t('exams.outOf') + " " + this.props.element_object.test_limit}
                               {this.props.element_object.test_limit==0 &&
                             this.props.t('exams.noLimit')
                             }
                           </span>
                        </div>
                     </div>
                  </div>
                  <div>
                     <div className="exam-image-div">
                        <img src={ghadi2} className="exam-dateimage"></img>
                        <div className="combine-date">
                           <span className="start-date"> {this.props.t('exams.duration')} </span>
                           <span className="start-dateformat"> 
                           {(this.props.element_object.duration || this.props.element_object.duration == 0)?( this.props.element_object.duration> 60 
                              ?
                               Math.trunc((this.props.element_object.duration/60))+ " " + this.props.t('exams.hr') + " " + (this.props.element_object.duration%60)+" " + this.props.t('exams.mins')
                              : 
                                this.props.element_object.duration + " " + this.props.t('exams.mins')):"-"}                        
                           </span>
                        </div>
                     </div>                    
                  </div>
               </div>
               <div className="exam-button-div">
                 {
                  (this.props.status ==="practice" && this.props.element_object.test_limit==0 && !this.props.auth.parentslogin) &&
                     <button className="exam-button" style={{ cursor: 'pointer' }} 
                     onClick={() => window.open(this.testpurl+"/"+authToken, 'location=yes,scrollbars=yes,status=yes')}                    
                     >{this.props.t('exams.start')}</button>
                  }

                  {(this.props.status ==="practice" && this.props.element_object.test_limit==0 && this.props.auth.parentslogin) &&
                     <button className="exam-button" style={{background:"rgb(227, 227, 227)",cursor: 'not-allowed'}}  onClick={()=>{toast.error(this.props.t('errors.parentsNoExam')); }}                    
                     >{this.props.t('exams.start')}</button>
                  }

                 {
                  this.props.status ==="practice" && this.props.element_object.test_limit>0 && 
                  this.props.element_object.total_attempts<this.props.element_object.test_limit && !this.props.auth.parentslogin &&
                     <button className="exam-button" style={{ cursor: 'pointer' }} 
                     onClick={() => window.open(this.testpurl+"/"+authToken, 'location=yes,scrollbars=yes,status=yes')}            
                     >{this.props.t('exams.start')}</button>
                  }

                 {
                  this.props.status ==="practice" && this.props.element_object.test_limit>0 && 
                  this.props.element_object.total_attempts<this.props.element_object.test_limit && this.props.auth.parentslogin &&
                     <button className="exam-button" style={{background:"rgb(227, 227, 227)",cursor: 'not-allowed'}}   onClick={()=>{toast.error(this.props.t('errors.parentsNoExam')); }}
                     >{this.props.t('exams.start')}</button>
                  }
                  {
                  this.props.status ==="practice" && this.props.element_object.test_limit>0 && 
                  this.props.element_object.total_attempts>=this.props.element_object.test_limit && !this.props.auth.parentslogin &&

                     <button className="exam-button" style={{background:"rgb(227, 227, 227)", cursor: 'pointer' }}>{this.props.t('exams.start')}</button>
                  }

                  {
                  this.props.status ==="practice" && this.props.element_object.test_limit>0 && 
                  this.props.element_object.total_attempts>=this.props.element_object.test_limit && this.props.auth.parentslogin &&

                     <button className="exam-button" style={{background:"rgb(227, 227, 227)",cursor: 'not-allowed'}}  onClick={()=>{toast.error(this.props.t('errors.parentsNoExam')); }}>{this.props.t('exams.start')}</button>
                  }
               </div>
            </div>
         </div>
      </>
   )
}
}

const mapStateToProps = state =>({auth:state.auth})
export default connect(mapStateToProps)(withTranslation()(ExamcardPr))